import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		logo: {
			height: 50,
			backgroundSize: "contain",
			backgroundPosition: "left",
		},
	} satisfies Record<string, CSSObject>);
};
